import React, { useEffect, useState } from 'react'
import MunicipiosApi from '../services/robinhood/MunicipiosApi'
import Header from '../components/home/Header';
import ContentBoxValores from '../components/extratos/ContentBoxValores';
import ContentBox from '../components/ContentBox';
import { Link } from 'react-router-dom';
import MapComponent from './Map';

export default function MunicipioSelecionarx(props) {
  const [municipios, setMunicipios] = useState([]);
  const [municipio, setMunicipio] = useState({ 'id': null, 'municipio': null });
  const [municipiosComparacao, setMunicipiosComparacao] = useState(localStorage.getItem('municipios') ? localStorage.getItem('municipios') : []);
  // const [municipio_id, setMunicipio_id] = useState(null);
  const [position, setPosition] = useState([-0.110, -47.20]);
  // const [position, setPosition] = useState([-19.852299394288814, -43.96476940798442]);
  const flyToPosition = [-19.852299394288814, -43.96476940798442];

  useEffect(() => {
    document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';

    new MunicipiosApi().all().then(response => {
      setMunicipios(response);
    });
  }, []);

  const HandlerMunicipio = async () => {
    if (municipio.id) {
      localStorage.setItem('municipio', JSON.stringify(municipio));
      await new MunicipiosApi().populacaoAproximada(municipio.id, 4).then(response => {
        const municipiosFilter = response.filter(item => item.id != municipio.id);
        municipiosFilter.push(municipio);
        if (response.length > 0)
          localStorage.setItem('municipios', JSON.stringify(municipiosFilter.reverse()));
        else
          localStorage.setItem('municipios', JSON.stringify([municipio]));
      });
    }
  }

  const onChangeMunicipio = (event) => {
    setMunicipio({ 'id': event.target.value, 'municipio': event.target.selectedOptions[0].text });
    document.getElementById('buttonFly').click();
  }

  return (
    <>
      <div className=''>
        <Header>
          <h5 style={{ marginLeft: '20px', marginBottom: '-15px', zIndex: '1000' }}> <i className='zmdi zmdi-city'></i> SELECIONE O MUNICÍPIO PARA CONSULTA DE DADOS </h5>
        </Header>
        <section className='content' style={{ marginBottom: '-30px', marginTop: '25px' }}>
          <div className='row block-header' style={{ marginTop: '' }}>
            <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12" >
              <div class="card" style={{ height: '119px' }}>
                <div class="body">
                  <h4> <i className='zmdi zmdi-pin' style={{ fontSize: '30px' }}></i> MUNICÍPIOS DISPONÍVEIS </h4>
                  {/* <p class="text-muted" style={{ marginBottom: '0px' }}>&nbsp;</p> */}
                  {/* <br /> */}
                  <div class="input-group col-md-12" key={Math.random()}>
                    <i className='zmdi zmdi-mouse small text-black m-t-10 m-r-5 blink_me'></i>
                    <select className='form-control bg-light' id='municipio_id' value={municipio.id || ''} onChange={(event) => onChangeMunicipio(event)} style={{ cursor: 'pointer', zIndex: 1000 }}>

                      <option value="" disabled>  CLIQUE PARA SELECIONAR UM MUNICÍPIO</option>
                      {municipios.map(municipio => {
                        return <option key={municipio.id} value={municipio.id}  > {municipio.municipio} </option>
                      })}
                    </select>
                    <div class="input-group-append col-md-4">
                      <Link style={{}} className='form-control col-md-12 btn bg-green waves-effect rounded' onClick={() => HandlerMunicipio()} to={'/'} > <i className='zmdi zmdi-check'></i> SELECIONAR </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 col-xs-12">
              <div class="card">
                <div class="body">
                  <h4> <i className='zmdi zmdi-city' style={{ fontSize: '30px' }}></i> {municipios.length}  MUNICÍPIOS  </h4>
                  {/* <p class="text-muted">MUNICIPIOS CADASTRADOS</p> */}
                  <div className="progress m-t-20">
                    <div className="progress-bar l-green" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }}></div>
                  </div>
                  <span class="text-small">ESTADO DE MINAS GERAIS</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className='' style={{ marginTop: '-120px' }}>
        <ContentBox>
          <MapComponent position={position} zoom={3} flyToPosition={flyToPosition} flyToZoom={6}></MapComponent>
        </ContentBox>
      </div>
      <div style={{ marginBottom: '90px' }}>

      </div>
    </>
  )
}
